import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';


export const getCombosReportData = (start, end) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/combos-vehicles/report?start=${start}&end=${end}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_COMBOS_DATA_REPORT,
        ActionTypes.FETCHED_COMBOS_DATA_REPORT,
        [ActionTypes.FETCHED_COMBOS_DATA_REPORT_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getCombosReportDataExcel = (start, end) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/combos-vehicles/report-excel?start=${start}&end=${end}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_COMBOS_DATA_REPORT_EXCEL,
        ActionTypes.FETCHED_COMBOS_DATA_REPORT_EXCEL,
        [ActionTypes.FETCHED_COMBOS_DATA_REPORT_EXCEL_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};
